import { AxiosResponse } from "axios";
import {
  ITemplatesResponseData,
  ITemplate,
} from "../../redux/reducers/ui/uiTypes";
import { studioAxiosInstance } from "./instances";

// Helper function to transform templates response to expected frontend structure
const transformTemplatesResponse = (data: any[]): ITemplatesResponseData => {
  return {
    count: data.length,
    rows: data.map(
      template =>
        ({
          id: template.id,
          name: template.name,
          image: template.image || null,
          userId: template.userId,
          folderId: template.folderId,
          config: template.config,
          createdAt: template.createdAt,
          updatedAt: template.updatedAt,
        }) as ITemplate
    ),
  };
};

//  Fetch all templates for a given folder

export const getTemplatesAPI = async (
  folderId: number
): Promise<AxiosResponse<ITemplatesResponseData>> => {
  const response = await studioAxiosInstance.get(
    `/templates?folderId=${folderId}`
  );
  return {
    ...response,
    data: transformTemplatesResponse(response.data),
  };
};

export const getTemplatesPaginatedAPI = async ({
  folderId,
  page,
  pageSize,
}: {
  folderId: number;
  page: number;
  pageSize: number;
}): Promise<AxiosResponse<ITemplatesResponseData>> => {
  const response = await studioAxiosInstance.get(
    `/templates?folderId=${folderId}&pageSize=${pageSize}&page=${page}`
  );
  return {
    ...response,
    data: transformTemplatesResponse(response.data),
  };
};

//   Create a new template

export const createTemplateAPI = async (
  formData: FormData
): Promise<AxiosResponse<any>> => {
  return await studioAxiosInstance.post(`/templates/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Delete a template
export const deleteTemplateAPI = async (
  templateId: number
): Promise<AxiosResponse<any>> => {
  return await studioAxiosInstance.delete(`/templates/${templateId}`);
};

// Overwrite a template
export const overwriteTemplateAPI = async (
  templateId: number,
  data: { config: any; image?: File }
): Promise<AxiosResponse<any>> => {
  // If image is provided, use multipart/form-data, otherwise use JSON
  if (data.image) {
    const formData = new FormData();
    const configString = JSON.stringify(data.config);
    formData.append("config", configString);
    formData.append("image", data.image);
    return await studioAxiosInstance.put(
      `/templates/${templateId}/overwrite`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  } else {
    return await studioAxiosInstance.put(
      `/templates/${templateId}/overwrite`,
      data.config,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  }
};

// Update an existing template
export const updateTemplateAPI = async (
  templateId: number,
  formData: FormData
): Promise<AxiosResponse<ITemplate>> => {
  return await studioAxiosInstance.put(`/templates/${templateId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Fetch a single template by its ID
export const getTemplateAPI = async (
  templateId: number
): Promise<AxiosResponse<ITemplate>> => {
  return await studioAxiosInstance.get(`/templates/${templateId}`);
};
